const dialogCls = "c2lde4qazj";
const iframeWrapperCls = "c2lipvq4h1";
const iframeCls = "c2limhtg02";
const throbberTransitionDurationMs = 100;
const throbberCls = "c2lt1tiqjz9";
const toolbarCls = "c2lt14ppho2";
const buttonCls = "c2lb1qdnwv8";

export { buttonCls, dialogCls, iframeCls, iframeWrapperCls, throbberCls, throbberTransitionDurationMs, toolbarCls };
import "./builder-lightbox.style.linaria.module.css";
//# sourceMappingURL=builder-lightbox.style.js.map
